// extracted by mini-css-extract-plugin
module.exports = {"attemptsLeftComponentTitle":"embed_attemptsLeftComponentTitle__2vMmg"};